// api/reportApi.js - Rapor istatistikleri için API fonksiyonları
import axios from 'axios';
import { getAuthHeader } from '../utils/authUtils';

// Ödeme yöntemlerine göre istatistikleri getir
export const getPaymentMethodStats = async () => {
  try {
    const response = await axios.get('/api/reports/payment-methods', { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Ödeme yöntemi istatistikleri hatası:', error);
    throw error.response?.data?.message || error.message || 'Ödeme yöntemi istatistikleri alınamadı';
  }
};

// İade tamamlanma süresi istatistiklerini getir
export const getCompletionTimeStats = async () => {
  try {
    const response = await axios.get('/api/reports/completion-time', { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Tamamlanma süresi istatistikleri hatası:', error);
    throw error.response?.data?.message || error.message || 'Tamamlanma süresi istatistikleri alınamadı';
  }
};

// Durum dağılımı istatistiklerini getir
export const getStatusDistribution = async () => {
  try {
    const response = await axios.get('/api/reports/status-distribution', { headers: getAuthHeader() });
    return response.data;
  } catch (error) {
    console.error('Durum dağılımı istatistikleri hatası:', error);
    throw error.response?.data?.message || error.message || 'Durum dağılımı istatistikleri alınamadı';
  }
}; 